<template>
  <div style="text-align: center;">
    <el-row>
      <el-col :span="20">
        <span style="font-size: 20px;margin-left: 100px" v-text="title"></span>
      </el-col>
      <el-col v-if="toVoid" :span="4" style="position: relative;left: -25px;top: -25px">
        <el-image style="width: 40px; height: 40px;" :src="require('./img/toVoid.png')"></el-image>
        <div style="color: red">
          作废
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    title: String,
    toVoid: Boolean
  }
}
</script>

<style scoped>

</style>
